import {
  Atom,
  Award,
  BookMarked,
  BookOpen,
  Bot,
  Brain,
  Calculator,
  Camera,
  Code,
  Coffee,
  FlaskConical,
  Gamepad2,
  Globe,
  GraduationCap,
  Heart,
  Lightbulb,
  Music,
  Palette,
  PenTool,
  Rocket,
  School,
  Shield,
  Smile,
  Sparkles,
  Star,
  Target,
  Trophy,
  User,
  Zap,
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';

export type TuteeIconComponent = React.ComponentType<{ className?: string }>;

const Jellyfish = ({ className, ...props }: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M4 11a8 8 0 0 1 16 0c0 4-2.5 7-8 7s-8-3-8-7Z" />
    <path d="M8 18v3" />
    <path d="M11 18v4" />
    <path d="M14 18v3" />
    <path d="M17 18v4" />
  </svg>
);

export const TUTEE_ICON_OPTIONS: Array<{
  name: string;
  label: string;
  component: TuteeIconComponent;
}> = [
  { name: 'BookOpen', label: 'Book', component: BookOpen },
  { name: 'GraduationCap', label: 'Graduation', component: GraduationCap },
  { name: 'User', label: 'User', component: User },
  { name: 'Star', label: 'Star', component: Star },
  { name: 'Heart', label: 'Heart', component: Heart },
  { name: 'Zap', label: 'Zap', component: Zap },
  { name: 'Target', label: 'Target', component: Target },
  { name: 'Award', label: 'Award', component: Award },
  { name: 'Trophy', label: 'Trophy', component: Trophy },
  { name: 'Lightbulb', label: 'Lightbulb', component: Lightbulb },
  { name: 'Brain', label: 'Brain', component: Brain },
  { name: 'Rocket', label: 'Rocket', component: Rocket },
  { name: 'Sparkles', label: 'Sparkles', component: Sparkles },
  { name: 'BookMarked', label: 'Bookmarked', component: BookMarked },
  { name: 'School', label: 'School', component: School },
  { name: 'PenTool', label: 'Pen', component: PenTool },
  { name: 'Calculator', label: 'Calculator', component: Calculator },
  { name: 'FlaskConical', label: 'Chemistry', component: FlaskConical },
  { name: 'Atom', label: 'Atom', component: Atom },
  { name: 'Music', label: 'Music', component: Music },
  { name: 'Palette', label: 'Palette', component: Palette },
  { name: 'Camera', label: 'Camera', component: Camera },
  { name: 'Gamepad2', label: 'Game', component: Gamepad2 },
  { name: 'Code', label: 'Code', component: Code },
  { name: 'Globe', label: 'Globe', component: Globe },
  { name: 'Coffee', label: 'Coffee', component: Coffee },
  { name: 'Smile', label: 'Smile', component: Smile },
  { name: 'Bot', label: 'Robot', component: Bot },
  { name: 'Jellyfish', label: 'Jellyfish', component: Jellyfish },
];

export const TUTEE_ICON_MAP: Record<string, TuteeIconComponent> = {
  ...Object.fromEntries(TUTEE_ICON_OPTIONS.map((icon) => [icon.name, icon.component])),
  Shield,
};

export const getTuteeIcon = (
  iconName: string,
  fallback: TuteeIconComponent = BookOpen
): TuteeIconComponent => {
  return TUTEE_ICON_MAP[iconName] || fallback;
};
